import React from 'react';
import { TELEPHONE_CODE } from 'modules/core/constants';

export const TelephoneCodeAdornment: React.FC = () => <span>{TELEPHONE_CODE}</span>;
